import i18n from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";
import enUS from './resources/en-us';
import esMX from './resources/es-mx';
import { GetBrandedAppName } from "../services/BrandingService";
import { useMemo } from "react";

const resources = {
    en: enUS,
    es: esMX,
};

const initi18n = (brandedAppName) => {
    i18n
        .use(initReactI18next) // passes i18n down to react-i18next
        .init({
            compatibilityJSON: 'v3',
            resources,
            fallbackLng: "en-us", // use en-us if detected lng is not available
            debug: process.env.NODE_ENV == 'development', // shows if we are missing any translation key / values,
            interpolation: {
                defaultVariables: {
                    brandedAppName,
                }
            },
        });
}

initi18n("Amira Learning");


export default i18n;
export {
    initi18n
}

// This function initializes a new i18next instance
export function createLocalI18n(language) {
  const localI18n = i18n.createInstance();
  const brandedAppName = GetBrandedAppName();
  localI18n.init({
    resources,
    lng: language,
    fallbackLng: "en-us",
    interpolation: {
      defaultVariables: {
        brandedAppName,
      }
    },
  });
  return localI18n;
}

export function useLocalTranslation(language, namespace=[]) {
  const i18n = useMemo(() => createLocalI18n(language), [language])
  return useTranslation(namespace, {i18n});
}